exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-romaneio-details {\n  width: 100%;\n  overflow-x: hidden;\n}\n.mt-8 {\n  margin-top: 8px;\n}\n.products-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n", ""]);

// exports
